export default "__VITE_ASSET__oGivVZM3__"